import { requestGet, requestPost, requestPut, requestDelete } from '../request';
import apiPath from './apiPath';

const api = {
  CreateVariantItem(payload) {
    return requestPost(apiPath.VARIANT.path, payload);
  },

  GetOneVariantItem(VariantItemID) {
    return requestGet(`${apiPath.VARIANT.path}/${VariantItemID}`);
  },

  GetAllVariantItem(paging, sorting, filtering) {
    filtering.category_id = filtering.category_id
      ? Number(filtering.category_id)
      : null;
    filtering.is_visable = filtering.is_visable
      ? filtering.is_visable === 'true'
      : null;
    return requestGet(apiPath.VARIANTS.path, {
      sortBy: sorting.byField,
      ...paging,
      f_outletCode: filtering.outlet_code,
      f_menuItemCode: filtering.menuItemCode,
      f_categoryName: filtering.category_name,
      f_isVisable: filtering.is_visable
    });
  },

  UpdateVariant(VariantID, payload) {
    payload.menu_item_code = payload.menuItemCode;
    delete payload.menuItemCode;
    return requestPut(`${apiPath.VARIANT.path}/${VariantID}`, payload);
  },

  DeleteVariant(VariantID) {
    return requestDelete(`${apiPath.VARIANT.path}/${VariantID}`);
  },

  GetAllCategoryItem(pagingVariantCategory, filteringVariantCategory) {
    return requestGet(apiPath.CATEGORIES.path, {
      ...pagingVariantCategory,
      f_name: filteringVariantCategory.name
    });
  },
  CreateVariantCategory(payload) {
    return requestPost(apiPath.CATEGORY.path, payload);
  },
  GetOneVariantCategory(VariantCategoryID) {
    return requestGet(`${apiPath.CATEGORY.path}/${VariantCategoryID}`);
  },
  UpdateVariantCategory(CategoryID, payload) {
    return requestPut(`${apiPath.CATEGORY.path}/${CategoryID}`, payload);
  },
  DeleteVariantCategory(CategoryID) {
    return requestDelete(`${apiPath.CATEGORY.path}/${CategoryID}`);
  }
};

export default api;
